<template>
  <v-parallax 
    :src="getImgUrl(inspiracao)" height="300"
  >
    <div style="
      background-color: rgba(0, 0, 0, 0.65);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    "></div>
    <v-row class="align-center justify-center text-center" pb-4 style="position: relative">
      <v-col cols="10" md="9">
        <div 
          class="grey--text text--lighten-1 font-weight-light text-xs-center"
          :class="{
            'display-1': $vuetify.breakpoint.mdAndUp,
            'headline': $vuetify.breakpoint.smAndDown
          }"
        >
          <span class="barlow">O que você busca está ali, depois do medo...</span>
        </div>
        <div
          class="pt-2 grey--text text--lighten-2 font-weight-medium text-xs-center"
          :class="{
            'display-2': $vuetify.breakpoint.mdAndUp,
            'display-1': $vuetify.breakpoint.smAndDown
          }"
        >
          <span class="barlow">OUSE IR ALÉM! PERMITA-SE VIVER SUA MELHOR VERSÃO!</span>
        </div>
      </v-col>
    </v-row>
  </v-parallax>
</template>

<script>
export default {
  data () {
    return {
      inspiracao: 'cta.jpg'
    }
  },
  methods: {
    getImgUrl(i) {
      return require('../assets/img/'+i)
    },
  }
}
</script>